import _ from 'underscore';

export const AppInstallAd = {
  parent: 'AdGroup',
  properties: {
    'bulk-upload-type': {
      type: 'string',
      value: 'App Install Ad',
    },
    AppPlatform: {
      'bulk-upload-header': 'App Platform',
    },
    AppStoreId: {
      'bulk-upload-header': 'App ID',
    },
    FinalUrls: {
      'bulk-upload-header': 'Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    MobileFinalUrls: {
      'bulk-upload-header': 'Mobile Final Url',
      'bulk-upload-mapper': function (value) {
        return value.join('; ');
      },
    },
    TrackingUrlTemplate: {
      'bulk-upload-header': 'Tracking Template',
    },
    FinalUrlSuffix: {
      'bulk-upload-header': 'Final Url Suffix',
    },
    UrlCustomParameters: {
      'bulk-upload-header': 'Custom Parameter',
      'bulk-upload-mapper': function (value) {
        return _.map(value, p => `{_${p.Key}}=${p.Value}`).join('; ');
      },
    },
    DevicePreference: {
      'bulk-upload-header': 'Device Preference',
    },
    CampaignName: {
      'bulk-upload-header': 'Campaign',
    },
    AdGroupName: {
      'bulk-upload-header': 'Ad Group',
    },
  },
};
